<template>
  <Component
    :is="overlay"
    v-if="overlay"
    @closed="closeOverlay(currentTab.value)"
  />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import type { Component } from 'vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import type { ApiTabValueType } from '../types';
import useApiRoutes from '../useApiRoutes';
import useApiTabs from '../useApiTabs';

import ApiWebhookCreateModal from './ApiWebhookCreateModal.vue';

const CREATE_COMPONENTS: Partial<Record<ApiTabValueType, Component>> = {
  webhooks: ApiWebhookCreateModal,
};

const route = useRoute();
const { getTabByValue } = useApiTabs();
const { closeOverlay } = useApiRoutes();

const currentTab = computed(() => getTabByValue(route.params.tab as string));
const overlay = computed(() => CREATE_COMPONENTS[currentTab.value.value]);

useHead({
  title: computed(() => `Create - ${currentTab.value.name} - API - Crossbeam`),
});
</script>
